module.exports = __webpack_public_path__ + "img/ax_eagle.986f1320.png";